import React, { useState, useEffect } from 'react'
import { Button, Select, Spin, Table, Avatar, Space, Popconfirm } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import moment from 'moment'
import axios from 'axios'

import Layout from '../../components/layout/Layout'
import axiosInstance from '../../utils/axiosInstance'

function AddProducts() {
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)
  const [organizations, setOrganizations] = useState([])
  const [products, setProducts] = useState([])
  const [selectedOrg, setSelectedOrg] = useState('')
  const auth = useSelector((state) => state.auth)

  const columns = [
    {
      title: '',
      dataIndex: 'attachments',
      key: 'attachments',
      render: (attachments) => <Avatar src={(attachments && attachments[0].mediaLink) || ``} />,
      width: 50,
    },
    {
      title: 'Product Name',
      key: 'name',
      render: (data) => <div>{data.name}</div>,
    },
    {
      title: 'Description',
      key: 'description',
      render: (data) => <div>{data.description}</div>,
    },
    {
      title: 'Required Points',
      key: 'requiredPoints',
      render: (data) => <div>{data.requiredPoints}</div>,
    },
    {
      title: 'Disabled',
      dataIndex: 'disabled',
      key: 'disabled',
      render: (dis) => (dis ? 'TRUE' : 'FALSE'),
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt) => <p style={{ fontSize: 9 }}>{moment(createdAt).format('DD MMMM YY h:mm a')}</p>,
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',

      render: (_, record) => (
        <Space size="middle">
          <a href={`/manageStore/addProducts?id=${record._id}`} target="_blank" rel="noopener noreferrer" style={{ color: '#1677ff', cursor: 'pointer' }}>
            Edit
          </a>

          {record.disabled ? (
            <Button type="ghost" style={{ color: '#1677ff', cursor: 'pointer' }} onClick={() => onDisable(`${record._id}`, false)}>
              Publish
            </Button>
          ) : (
            <Popconfirm
              title="Are you sure to Disable this?"
              description="This will no longer visible to users."
              onConfirm={() => onDisable(`${record._id}`, true)}
              onCancel={() => {}}
              okText="Yes"
              cancelText="No"
            >
              <Button type="ghost" style={{ color: 'red', cursor: 'pointer' }}>
                Disable
              </Button>
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ]

  const onDisable = async (id, disabled) => {
    const fmData = new FormData()

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        authorization: `Bearer ${auth.token}`,
      },
    }
    fmData.append('disabled', disabled)
    fmData.append('removedAttachmentNames', JSON.stringify([])) // Its required at backend

    const res = await axios.put(`${process.env.REACT_APP_BASE_URL}/api/v1/storeFront/editProduct?docId=${id}`, fmData, config)
    console.log(res.data)

    alert('Success')
    window.location.reload()
  }

  const handleChange = (value) => {
    setSelectedOrg(value)
    getProducts(value)
  }

  const getMyInfo = async () => {
    try {
      setLoading(true)

      const response = await axiosInstance.get(`/api/v1/admin/me`)

      // Check the admin organizations
      if (response?.data?.user?.organizations && response?.data?.user?.organizations.length > 0) {
        const org = response.data.user.organizations
        // console.log(org)

        // store to render at JSX
        org.forEach((element, idx) => {
          setOrganizations((prevElements) => [
            ...prevElements,
            {
              value: element._id,
              label: element.name,
            },
          ])
        })
      }
      setLoading(false)
    } catch (e) {
      console.log(e)
    }
  }

  const getProducts = async (org) => {
    try {
      setLoading(true)

      const query = org ? `?orgId=${org}` : ''
      const response = await axiosInstance.get(`/api/v1/storeFront/getProducts${query}`)

      setProducts(response.data.products)

      setLoading(false)
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    getMyInfo()
    getProducts() // calling without param to get all the products initially
  }, [])

  return (
    <Layout>
      <Button
        onClick={() => {
          navigate(-1)
        }}
      >
        Back
      </Button>
      <h2>View Products</h2>

      {loading && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Spin size="large" />
        </div>
      )}

      {organizations.length > 0 && (
        <div style={{ marginBottom: 10 }}>
          <p>Choose organization</p>
          <Select
            placeholder="Please select club or business"
            style={{
              width: 250,
              marginRight: 10,
            }}
            onChange={handleChange}
            options={organizations}
          />
        </div>
      )}

      <Table
        scroll={{
          x: 1300,
        }}
        dataSource={products}
        columns={columns}
        rowKey="_id"
        pagination={false}
      />
    </Layout>
  )
}

export default AddProducts
